import { useEffect, useRef } from 'react';
import { useGlobalContext } from '~/context/GlobalContext';
import AddButton from '~/components/ChatControls/AddButton';
import EmoticonButton from '~/components/ChatControls/EmoticonButton';
import TextInput from '~/components/ChatControls/TextInput';
import SendButton from '~/components/ChatControls/SendButton';
import Search from '~/components/ChatControls/Search';
import styles from './ChatControls.module.css';

const ChatControls = () => {
  const textInputRef = useRef<HTMLInputElement>(null);
  const chatControlsRef = useRef<HTMLInputElement>(null);
  const { context, setContext } = useGlobalContext();

  return (
    <div
      data-compoent="ChatControls"
      ref={chatControlsRef}
      className={styles.chatControls}>
      {context.activeSidebarId ? (
        <Search/>
      ) : (
        <>
          {/* <AddButton /> */}
          <EmoticonButton />
          <TextInput textInputRef={textInputRef} />
          <SendButton textInputRef={textInputRef} />
        </>
      )}
    </div>
  );
};

export default ChatControls;
